import React from 'react';

/**
 * Icon component wrapping a PNG asset from /icons/ folder.
 * Uses currentColor is not possible (raster), so the color of the PNG
 * is what it is. Icons are sourced from Špela's reference sheets.
 */
export const IconImg = ({ src, alt = '', size = 72, className = '', style }) => (
  <img
    src={src}
    alt={alt}
    width={size}
    height={size}
    className={`inline-block object-contain ${className}`}
    style={{ width: size, height: size, ...style }}
    aria-hidden={alt === '' ? true : undefined}
    loading="lazy"
    decoding="async"
  />
);

/* Ready-to-use bindings for home NEEDS cards */
export const HomeIcons = {
  Dojencek: '/icons/home_1_dojencek.png',
  Nosecnost: '/icons/home_2_nosecnost.png',
  Steklenicka: '/icons/home_3_steklenicka.png',
  MamaZDojenckom: '/icons/home_4_mama_dojencek.png',
  SkodelicaSrce: '/icons/home_5_skodelica_srce.png',
  DotikRok: '/icons/home_6_dotik_rok.png',
};

/* Ready-to-use bindings for subpage headers */
export const SubIcons = {
  PrviDnevi: '/icons/sub_2_prvi_dnevi.png',
  Hranjenje: '/icons/sub_3_hranjenje.png',
  TvojeTelo: '/icons/sub_4_tvoje_telo.png',
  Povezanost: '/icons/sub_5_povezanost.png',
};
